module.exports = __webpack_public_path__ + "img/1.5db3b9df.jpg";